// Single source of truth for role-based capabilities in the UI.
export const ROLE_HOME = {
  admin: '/dashboard',
  partner: '/roadmap',
  developer: '/tasks',
  restaurant: '/submit-request',
};

export const homeFor = (role) => ROLE_HOME[role] || '/dashboard';

// Partners manage the CRM with the same rights as admins.
export const canManageRestaurants = (user) => ['admin', 'partner'].includes(user?.role);
